import React from 'react';
import { PieChart } from '@mui/x-charts/PieChart';
import { useGetUsersByJobQuery } from '../../Apis/authApi';
import { 
  CircularProgress, 
  Box, 
  Typography, 
  Card, 
  CardHeader, 
  CardContent 
} from "@mui/material";

// Define the interface based on your C# backend response


export default function JobChart() {
  const { data: reportData, isLoading, isError } = useGetUsersByJobQuery();

  if (isLoading)
    return (
      <Box sx={{ display: "flex", justifyContent: "center", p: 5 }}>
        <CircularProgress />
      </Box>
    );

  if (isError)
    return <Typography color="error">Error loading job report.</Typography>;

  // Transform data for PieChart: label, value, and id are required
  const chartData = (reportData ?? []).map((item, index) => ({
    id: index,
    value: item.count,
    label: item.jobType, // Will be "Pharmacist" or "Other"
  }));

  return (
    <Card
      sx={{
        borderRadius: 3,
        boxShadow: 3,
        overflow: "hidden",
      }}
    >
      <CardHeader
        sx={{ background: "#f8f8f8" }}
        title={
          <Typography
            variant="h6"
            sx={{ color: "#eb3c96", fontWeight: "bold", m: 0 }}
          >
            User Profession Distribution
          </Typography>
        }
      />
      <CardContent>
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: 300,
          }}
        >
          {chartData.length > 0 ? (
            <PieChart
              series={[
                {
                  data: chartData,
                  highlightScope: { fade: "global", highlight: "item" },
                  faded: {
                    innerRadius: 30,
                    additionalRadius: -30,
                    color: "gray",
                  },
                  innerRadius: 30,
                  outerRadius: 100,
                  paddingAngle: 5,
                  cornerRadius: 5,
                  
                },
              ]}
              // Colors for Pharmacist and Other
              colors={["#512384", "#eb3c96"]}
              height={300}
              slotProps={{
                legend: {
                  direction:'horizontal',                  
                  position: { vertical: "bottom", horizontal: "center" },
                 
                },
              }}
            />
          ) : (
            <Typography>No data available for the report.</Typography>
          )}
        </Box>
      </CardContent>
    </Card>
  );
}